export let state = {
    brandId: null,
    url: null,
    showPoweredBy: null,
    primaryColor: null,
    secondaryColor: null,
    fontColor: null,
    brandLoadingStatus: false,
    images: {}
}